import { useForm } from 'react-hook-form'
import { saveUserFeedback } from '@pole-api/lib-ifa-communication-api/lib/clients/saveUserFeedback'
import { useMutation } from '@tanstack/react-query'
import type { IFinancingUxFeedbackFormValues } from './types'

export const useUxFeedbackForm = (onSuccess: () => void, onError: () => void) => {
  const { ...formMethods } = useForm<IFinancingUxFeedbackFormValues>()
  const { watch, handleSubmit } = formMethods
  const { mutateAsync: sendUserFeedback } = useMutation({ mutationFn: saveUserFeedback, onSuccess, onError })

  const grade = watch('grade')
  const feedback = watch('comment')
  const isNotDisabledAction = Boolean(grade) || Boolean(feedback)

  const onSubmitForm = async (value: IFinancingUxFeedbackFormValues) => {
    await sendUserFeedback({ grade: value.grade ? Number(value.grade) : 0, comment: value.comment })
  }

  return {
    handleSubmit,
    onSubmitForm,
    isNotDisabledAction,
    formMethods: { ...formMethods },
  }
}
